// 生成uuid
export function uuid() {
  const s = [];
  const hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  const uuid = s.join("");
  return uuid;
}

// 文件下载
export function downloadFileFun(url) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none'; // 防止影响页面
  iframe.style.height = 0; // 防止影响页面
  iframe.src = url;
  document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  setTimeout(() => {
    iframe.remove();
  }, 5 * 60 * 1000);
}

// 新标签页打开（window.open有些浏览器会拦截）
export function newTabLink(url) {
  const aEle = document.createElement('a');
  aEle.href = url;
  aEle.target = '_blank';
  aEle.click();
  aEle.remove();
}


// 将字符串中的回车符转为 <br>
export function strEnterReplace(text) {
  if(!text) return '---';
  return text.replace(/\n/g, "<br>");
}

// 生成防抖函数
export function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * @description: 根据 state 生成 mutation
 * @param {*} stateData state对象
 * @return {*}
 */
export const createMutation = (stateData) => {
  const data = {}
  for (const key in stateData) {
    const mutationKey = 'SET_' + key.replace(/[A-Z]/g, (match) => `_${match}`).toUpperCase()
    data[mutationKey] = (state, val, a = key) => {
      state[a] = val
    }
  }
  return data
}

// 时区时间转换

export const  dayjsFormat = (localtime,localtimezone)=>{
  var dayjs = require('dayjs')
  var utc = require('dayjs/plugin/utc')
  var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
  dayjs.extend(utc)
  dayjs.extend(timezone)
  // dayjs.extend(customParseFormat)
  let localtimeUtc=  TimeUtils.formatUTC(localtime)
  let timeres=dayjs.tz(localtimeUtc,localtimezone)
  let timeresY=timeres.tz("Asia/Shanghai").format('YYYY-MM-DD HH:mm')
  let sendtimestamp=dayjs(timeresY).valueOf()//转换服务器时区的时间戳
  let localTimeTamp=dayjs().valueOf()
  let dayObj={
    sendtimestamp:sendtimestamp,//需要发送的时间戳
    timeresY:timeresY,
    localTimeTamp:localTimeTamp//当前服务器的时间戳
  }
  return dayObj
}
export const TimeUtils = {
  format(fmt, date = new Date()) {
    date = new Date(date);
    let ret;
    let opt = {
      'Y+': date.getFullYear().toString(), // 年
      'M+': (date.getMonth() + 1).toString(), // 月
      'D+': date.getDate().toString(), // 日
      'h+': date.getHours().toString(), // 时
      'm+': date.getMinutes().toString(), // 分
      's+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
      }
    }
    return fmt;
  },
  formatUTC: (localtime) => {
    let time = TimeUtils.format('YYYY-MM-DD hh:mm:ss',  localtime)
    time = time.replace(/\//g, '-')
    time = time.replace(' ', 'T')
    time = time + '.000Z' // .000z是仿带Z格式随意加上的，可以是任意三位数字加Z
    return time
  }
};

//判断链接中是否有？号
export function openWindow(url, ad) {
  if (url) {
    if (url.indexOf("?") != -1) {
      if (ad) {
        window.location.href = `${url}&&ad=${ad}`;
      } else {
        window.location.href = `${url}`;
      }
    } else {
      if (ad) {
        window.location.href = `${url}?ad=${ad}`;
      } else {
        window.location.href = `${url}`;
      }
    }
  }
}
/**
 * 截取文件后续  不加点.   
 * 例如: name.pdf  返回 pdf   
 * name.PDF 返回 pdf    已做转换小写
 * @returns 
 */
export const getExtension = (filename) => {
  const match = filename.match(/\.([^.]+)$/);
  return match ? match[1].toLowerCase() : "";
};
